export const iconFontAwesomeWeatherSmog = (
	<i className="fa-solid fa-smog"></i>
);
